import { FunctionComponent } from 'react';
import Highlighter from 'react-highlight-words';

import useQuery from 'hooks/useQuery';
import useSearchWords from 'hooks/useSearchWords';
import { QueryType } from 'store/slices/query';

import { HIGHLIGHT_PROPS } from './constants';

export interface TextCellProps {
  value?: string;
  className?: string;
  queryTerm?: QueryType;
}

const TextCell: FunctionComponent<TextCellProps> = function ({
  value,
  className = 'flex flex-col text-14-22 text-neutral-900',
  queryTerm = 'users',
}) {
  const [query] = useQuery(queryTerm);
  const searchWords = useSearchWords(query);

  return (
    <div className={className}>
      <Highlighter
        {...HIGHLIGHT_PROPS}
        searchWords={searchWords}
        textToHighlight={value || ''}
      />
    </div>
  );
};

export default TextCell;
